import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthenticateService} from './authenticate.service';
import {environment} from '../../environments/environment';
import {Observable, throwError as observableThrowError} from 'rxjs';
import {EvendProductSearchFilter, EvendProductSearchFilterSuperAdmin, EvendProductType} from '../models/evendProduct';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ProductService {

    public headers =  new HttpHeaders({ 'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.authenticationService.token});

    constructor(private http: HttpClient,
                private authenticationService: AuthenticateService) { }

    getAllProducts(isHot): Observable<any> {
        /*eslint-disable */
        return this.http.get(environment.apiBaseUrl + 'products-all/' + isHot,
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    getBasketHistoryProducts(basketHistoryId): Observable<any> {
        /*eslint-disable */
        return this.http.post(environment.apiBaseUrl + 'getBasketHistoryProducts',
            JSON.stringify({basketHistoryId: basketHistoryId}),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    searchProducts(page: number, category: string, brand: string, name: string): Observable<any> {
        /*eslint-disable */
        return this.http.post(environment.apiBaseUrl + 'search-products/' + page,
            JSON.stringify({ categoryId: category, brandId: brand, name: name }),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    getEvendProductsSuperAdmin(page: number, params: EvendProductSearchFilterSuperAdmin): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'get-evend-products-super-admin/' + page,
          JSON.stringify(params),
          { headers: this.headers})
          .pipe(
            catchError((error: any) => observableThrowError(error.error || 'Server error')));
    }

    createProduct(product: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'product',
            JSON.stringify(product),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateProduct(product: any, id: string): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'product/' + id,
            JSON.stringify(product),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateEvendProduct(evendProduct: any, id: string,evendProductType: string): Observable<any> {
        evendProduct.evendProductType = evendProductType;
        return this.http.put(environment.apiBaseUrl + 'update-evend-product/' + id,
            JSON.stringify({evendProduct}),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteProduct(_id: string): Observable<any> {
        /*eslint-disable */
        return this.http.delete(environment.apiBaseUrl + 'product/' + _id,
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }
    deleteEvendProduct(_id: string): Observable<any> {
        /*eslint-disable */
        return this.http.delete(environment.apiBaseUrl + 'delete-evend-product/' + _id,
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    getEvendProductTypes(page: number): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-evend-product-types/' + page,
          { headers: this.headers})
          .map((res: Response) => {
            return res;
        })
        // ...errors if any
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createEvendProductType(product: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'create-evend-product-type',
            JSON.stringify({evendProductType: product}),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    deleteEvendProductType(_id: string): Observable<any> {
        /*eslint-disable */
        return this.http.delete(environment.apiBaseUrl + 'delete-evend-product-type/' + _id,
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }
    updateEvendProductType(product: EvendProductType, id: string): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'update-evend-product-type/' + id,
            JSON.stringify({evendProductType: {
                name: product.name, status: +product.status
            }}),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    uploadEvendProductImage(file , id: string): Observable<any>{
        return this.http.post(environment.apiBaseUrl + 'evend-product-image/'+ id, file)
          .pipe(
            catchError((error: any) => observableThrowError(error.error || 'Server error')));
    }

    createEvendProduct(evendProduct: any, evendProductType:string): Observable<any> {
        evendProduct.evendProductType = evendProductType;
        return this.http.post(environment.apiBaseUrl + 'create-evend-product',
            JSON.stringify({evendProduct}),
            { headers: this.headers})
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/product.service.ts